/* eslint-disable no-return-assign */
/* eslint-disable multiline-ternary */
import Cookies from 'js-cookie';
import _ from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import { HiOutlineLogout, HiOutlineUser } from 'react-icons/hi';
import { MdOutlineBookmarks } from 'react-icons/md';
import { RiCloseFill } from 'react-icons/ri';
import { REDIRECT_MEMBER, SHOW_COMMEMORATE, SHOW_RIBBON } from 'src/constants';
import styled from 'styled-components';
// import { PROVIDERS_MEMBER_AUTHO } from './WidgetLoginAuthO';
import { BsLine } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';

const MENU_LIST = [
  {
    id: 'profile',
    nameTH: 'ข้อมูลส่วนตัว',
    nameEN: 'Profile',
    link: '/member/profile',
    icon: <HiOutlineUser size={16} />
  },
  {
    id: 'following',
    nameTH: 'แท็กที่คุณสนใจ',
    nameEN: 'Following',
    link: '/member/following',
    icon: <MdOutlineBookmarks size={16} />
  },
  {
    id: 'signout',
    nameTH: 'ออกจากระบบ',
    nameEN: 'Sign out',
    link: '/',
    icon: <HiOutlineLogout size={16} />
  }
];

const TEXT_LIST = [
  {
    nameTH: 'เข้าสู่ระบบ',
    nameEN: 'Login'
  },
  {
    nameTH: 'เชื่อมต่อกับ',
    nameEN: 'Login with'
  },
  {
    nameTH: 'รายละเอียดเพิ่มเติม',
    nameEN: 'more details'
  }
];

const PROVIDERS_MEMBER_AUTHO = NEXTAUTH_URL => [
  {
    provider: 'google-oauth2',
    id: 'google',
    name: 'Google',
    type: 'oauth',
    icon: <FcGoogle id='google' size={20} />,
    signinUrl: `${NEXTAUTH_URL}/api/auth/signin/google`,
    callbackUrl: `${NEXTAUTH_URL}/api/auth/callback/google`
  },
  {
    provider: 'line',
    id: 'line',
    name: 'Line',
    type: 'oauth',
    icon: <BsLine id='line' size={20} />,
    signinUrl: `${NEXTAUTH_URL}/api/auth/signin/line`,
    callbackUrl: `${NEXTAUTH_URL}/api/auth/callback/line`
  }
];

export const WidgetLoginSubscribe = ({
  refKey,
  children,
  textButton,
  nextAuthUrl,
  router,
  sendDataLayerGlobal,
  DATALAYER_TYPE,
  conditionDisabled,
  error,
  sessionSevId,
  open,
  setOpen,
  setError,
  _key,
  isEn = false,
  isRemoveCookie = true,
  redirectUrl = '',
  className
}) => {
  if (_.isEmpty(PROVIDERS_MEMBER_AUTHO(nextAuthUrl))) return null;
  const [cookie, setCookie] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // const [auth0Client, setAuth0Client] = useState(null);

  useEffect(() => {
    setCookie(Cookies.get('login'));
  }, []);

  // handleCommemorate
  const handleLogin = async (item, index, redirectUrl) => {
    setIsLoading(true);
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);
    localStorage.setItem('login_channel', item?.provider);
    sendDataLayerGlobal({
      type: DATALAYER_TYPE.TRACK_INDEX,
      router: router?.pathname,
      section: 'login',
      data: {
        heading: `เชื่อมต่อกับ ${item?.id}`,
        title: _key,
        index: index + 1
      }
    });
    if (_.isEmpty(redirectUrl)) {
      // console.log('#1');
      window.location.href = `/api/auth/login?provider=${item?.provider}`;
    } else {
      // console.log('#2');
      Cookies.set('login-redirect', redirectUrl, { expires: 1 / 1440, sameSite: 'None', secure: true });
      window.location.href = `/api/auth/login?provider=${item?.provider}&redirectUrl=${redirectUrl}`;
    }
  };
  function handleLogout() {
    // ลบ Cookies ที่เกี่ยวข้องกับการล็อกอิน
    if (isRemoveCookie) {
      Cookies.remove('login-data');
      localStorage.removeItem('login_channel');
      localStorage.removeItem('login-meta-data');
    }
    localStorage.removeItem('login-meta-data');
    Cookies.remove('login-state');
    Cookies.remove('login-redirect');
    window.location.href = '/api/auth/logout';

    // เปลี่ยนเส้นทางไปยังหน้าออกจากระบบของ Auth0
  }
  // console.log('WidgetLoginSubscribe', sessionSevId, refKey, sessionSevId?.picture);

  return (
    <WidgetWrapper id='widget-subscribe'>
      {!_.isEmpty(sessionSevId) ? (
        <>
          <ButtonSubscribe
            className={`button-subscribe ${className}`}
            isCommemorate={SHOW_COMMEMORATE === 'true' ? 'true' : SHOW_RIBBON}
            style={{ filter: SHOW_RIBBON === 'true' || SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}
            onClick={() => {
              if (refKey === 'subscribe') {
                window.location.href = redirectUrl;
                sendDataLayerGlobal({
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  position: 'on:header',
                  section: 'login',
                  data: {
                    title: _key,
                    heading: 'open-login'
                  }
                });
              } else {
                sendDataLayerGlobal({
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  position: 'on:header',
                  section: 'login',
                  data: {
                    title: _key,
                    heading: 'open-login'
                  }
                });
              }
            }}
          >
            {refKey === 'subscribe' ? (
              <div>{textButton}</div>
            ) : !_.isEmpty(sessionSevId?.picture) && typeof sessionSevId?.picture === 'string' ? (
              <div className='flex-center'>
                <img className='image-user' src={sessionSevId?.picture} width={30} height={30} title='profile' alt='profile' />
                {sessionSevId?.given_name && <p className='username'>{sessionSevId?.given_name}</p>}
              </div>
            ) : null}
          </ButtonSubscribe>

          {refKey === 'login' && (
            <ul className='menu-list' style={{ filter: SHOW_RIBBON === 'true' || SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : 'unset' }}>
              {MENU_LIST.map((item, index) => (
                <Fragment key={index}>
                  {item.id === 'signout' ? (
                    <li
                      className='list-item'
                      // href={item?.link}
                      // title={item.nameTH}
                      onClick={() => {
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          position: 'on:header',
                          section: 'login',
                          data: {
                            title: sessionSevId?.email || _key,
                            heading: item?.nameTH,
                            index: index + 1
                          }
                        });
                        handleLogout();
                      }}
                    >
                      {item?.icon}
                      <p>{isEn ? item?.nameEN : item?.nameTH}</p>
                    </li>
                  ) : (
                    <li className='list-item'>
                      <a
                        href={item?.link}
                        title={item.nameTH}
                        onClick={() => {
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            position: 'on:header',
                            section: 'login',
                            data: {
                              title: sessionSevId?.email || _key,
                              heading: item?.nameTH,
                              index: index + 1
                            }
                          });
                        }}
                      >
                        {item?.icon}
                        <p>{isEn ? item?.nameEN : item?.nameTH}</p>
                      </a>
                    </li>
                  )}
                </Fragment>
              ))}
            </ul>
          )}
        </>
      ) : (
        <>
          <ButtonSubscribe
            className={`button-subscribe ${className}`}
            isCommemorate={SHOW_COMMEMORATE === 'true' ? 'true' : SHOW_RIBBON}
            style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                position: 'on:header',
                section: 'login',
                data: {
                  title: _key,
                  heading: 'open-login'
                }
              });
              setOpen(true);
            }}
          >
            {textButton}
          </ButtonSubscribe>
          {open && (
            <WidgetSocial id='widget-social' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
              <div className='modal-social'>
                {
                  <button
                    className='btn-close'
                    onClick={() => {
                      if (open) {
                        setError('');
                        setOpen(false);
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          position: 'on:header',
                          section: 'login',
                          data: {
                            title: _key,
                            heading: 'close-login'
                          }
                        });
                      }
                    }}
                  >
                    <RiCloseFill size={25} />
                  </button>
                }
                <div className='heading'> {isEn ? TEXT_LIST[0].nameEN : TEXT_LIST[0].nameTH} </div>
                {isLoading ? (
                  <CircularLoadWrapper className='circle-loader'>
                    <div className='circle border'></div>
                  </CircularLoadWrapper>
                ) : (
                  PROVIDERS_MEMBER_AUTHO(nextAuthUrl).map((item, index) => (
                    <>
                      <button
                        key={index}
                        className={`btn-social ${item.id ? `icon-${item.id} ${conditionDisabled ? 'disabled' : ''}` : ''}`}
                        // disabled={conditionDisabled}
                        onClick={() => {
                          if (conditionDisabled) {
                            setError('* กรุณายอมรับนโยบาย');
                          } else {
                            // Cookies.set('login', 'success', { expires: expiryDate, sameSite: 'None', secure: true }); // 1 Month
                            handleLogin(item, index, redirectUrl);
                          }
                        }}
                      >
                        {item?.icon}
                        <p>
                          {!isEn ? TEXT_LIST[1].nameTH : TEXT_LIST[1].nameEN} <span> {item?.id}</span>
                        </p>
                      </button>
                    </>
                  ))
                )}
                {!_.isEmpty(error) && <label className='error-label'> {!conditionDisabled ? '' : error}</label>}

                {!cookie && (
                  <>
                    {children}
                    <a
                      className='link-policy'
                      href='/privacy-policy'
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={() =>
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK,
                          router: router?.pathname,
                          section: 'login',
                          data: {
                            title: _key,
                            heading: 'รายละเอียดเพิ่มเติม'
                          }
                        })
                      }
                    >
                      {!isEn ? TEXT_LIST[2].nameTH : TEXT_LIST[2].nameEN}
                    </a>
                  </>
                )}
              </div>
            </WidgetSocial>
          )}
        </>
      )}
    </WidgetWrapper>
  );
};
const WidgetWrapper = styled.div`
  position: relative;
  display: block;
  padding: 8px 0 8px 16px;
  @media (max-width: 768px) {
    padding: 0;
    /* padding: 8px 10px 8px 16px; */
  }
  &:hover {
    .menu-list {
      display: flex;
    }
    .btn-login {
      svg {
        color: #ffffffba;
      }
    }
  }
  /* ------------------------------ BUTTON LOGIN ------------------------------ */
  .btn-login {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;

    padding: 0;
    border: none;
    border-radius: 50px;
    &.login {
      border: 2px solid var(--text-color);
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
    }

    svg {
      color: var(--text-color);
      @media (max-width: 690px) {
        height: 24px;
        width: 24px;
      }
    }
  }

  .info {
    font-size: 12px;
    font-weight: 300;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .username,
    .email {
      width: 150px;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;

      padding: 5px;
      margin: 0;
    }
  }

  .menu-list {
    z-index: 100 !important;
    display: none;
    position: absolute;
    top: 50px;
    right: 0;
    background-color: #ffffff;
    box-shadow: 1px 0px 10px 0px var(--primary-color);
    width: max-content;
    flex-direction: column;
    border-radius: 5px;
    margin: 0;
    padding: 10px !important;
    &:before {
      content: '';
      position: absolute;
      top: -8px;
      right: 0px;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid white;
    }
    @media (max-width: 767px) {
      left: auto;
      right: 10px;
      top: 47px;
      &:before {
        top: -5px;
        right: 10px;
        left: auto;
      }
    }
    .list-item {
      width: 100%;
      margin: 0;
      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
    }

    svg {
      color: var(--primary-color);
      font-weight: 700;
      margin-left: 5px;
      margin-bottom: 2px;
      transition: all 3ms ease-in;
    }
    li {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      padding: 8px;
      font-family: 'DBHelvethaica', sans-serif;
      gap: 5px;
      z-index: 2;
      border-radius: 5px;
      p {
        padding: 0;
        margin: 0;
        color: var(--primary-color);
      }
      &:hover {
        box-shadow: 1px 0px 10px 0px rgba(237, 26, 59, 0.3);
        background-color: var(--primary-color);
        p,
        svg {
          color: #fff;
        }
      }
    }
  }
`;

const WidgetSocial = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 15;
  .bottom-line {
    width: 100%;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  .modal-social {
    background: linear-gradient(103.43deg, #f6f6f6 0%, #eeeeee 100%);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.85);
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    gap: 16px;
    padding: 40px 30px;
    @media (max-width: 767px) {
      padding: 20px;
      width: 320px;
    }
    @media (max-width: 380px) {
      width: 300px;
    }

    .heading {
      color: var(--primary-color);
      font-size: 26px;
      font-weight: 900;
      display: block;
      text-align: center;
      margin-bottom: 10px;
      /* border-bottom: 1px solid var(--primary-color); */
      /* padding-bottom: 15px; */
      @media (max-width: 767px) {
        font-size: 24px;
      }
      @media (max-width: 380px) {
        margin-top: 10px;
        margin-bottom: 5px;
      }
    }
    /* ------------------------------ BUTTON CLOSE ----------------------------- */
    .btn-close {
      position: absolute;
      top: 20px;
      right: 10px;
      cursor: pointer;
      border: none;
      background-color: transparent;
      transition: all ease 0.25ms;

      display: flex;
      justify-content: flex-end;
      align-items: center;
      svg {
        color: var(--primary-color);
      }
      @media (max-width: 767px) {
        top: 10px;
      }

      &:hover {
        color: #474747;
      }
    }
    /* ------------------------------ BUTTON SOCIAL ----------------------------- */
    .btn-social {
      cursor: pointer;
      transition: background-color ease-in-out 100ms;
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
      background-color: #ffffff;
      border-radius: 50px;
      color: #fff;
      border: 0;

      gap: 16px;
      padding: 16px 30px;

      width: 100%;
      max-width: 345px;
      margin: auto;
      height: 48px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media (max-width: 767px) {
        padding: 16px;
      }
      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 1.25;
        color: #111;

        span {
          text-transform: capitalize;
        }
        @media (max-width: 767px) {
          font-size: 16px;
        }
      }

      &.icon-google {
        color: #000000;
        background: #ffffff;
        &:hover {
          background: #e5e5e5;
          color: #ffffff;
        }
      }
      &.icon-facebook {
        background: #ffffff;
        svg {
          color: #337fff;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-line {
        background: #ffffff;
        svg {
          color: #3ace01;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-tiktok {
        background: #ffffff;
        svg {
          color: #000;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-linkin {
        background: #ffffff;
        svg {
          color: #337fff;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
    }
  }
`;

const CircularLoadWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  align-self: center;
  margin: 10px 50px;
  .circle {
    height: 100%;
    right: 0px;
    position: absolute;
    border: solid 15px #a9a9a9;
    border-top-color: #000;
    border-radius: 50%;
  }

  .border {
    width: 100%;
    transform: rotate(135deg);
    animation: spin 1.3s steps(2) 0.2s infinite;
    -webkit-animation: spin 1.3s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const ButtonSubscribe = styled.div`
  position: relative;
  background-color: ${props => (props?.isCommemorate === 'true' ? '#000000ff' : '#0040fd')};
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 5px 20px;
  border-radius: 50px;
  cursor: pointer;
  border: 1px solid ${props => (props?.isCommemorate === 'true' ? '#000000ff' : '#0040fd')};
  color: var(--white-color);
  font-weight: 600;
  font-size: 22px;
  width: 120px;
  height: 40px;
  &:hover {
    opacity: 0.8;
  }
  .image-user {
    overflow: hidden;
    margin: 0px;
    padding: 0px;
    border-radius: 50px;
    object-fit: cover;
    min-width: 25px;
    width: 25px;
    height: 25px;
    border-radius: 50px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .username {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
    padding: 0px;
    margin-left: 10px;
  }
  &.--blue {
    background-color: ${props => (props?.isCommemorate === 'true' ? '#000000ff' : '#0040fd')};
    color: #fff;
  }
`;
